import './Main.css';
import Header from '../../components/Header/Header';
import { useEffect, useState, useRef } from 'react';
import gsap from 'gsap';

const Main: React.FC = () => {
    const [isAnimationVisible, setIsAnimationVisible] = useState<boolean>(false);
    const animationContainerRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const isFirstVisit = !sessionStorage.getItem('animationShown');

        if (isFirstVisit) {
            setIsAnimationVisible(true);
            sessionStorage.setItem('animationShown', 'true');
        }

        const textPart1 = 'Добро пожаловать!';
        const textPart2 = 'Вы попадаете в пространство';
        const textPart3 = 'Miartcom';

        const createTextHTML = (text: string) =>
            text
                .split('')
                .map((char) => `<span>${char === ' ' ? '&nbsp;' : char}</span>`)
                .join('');

        const formattedHTML = `
            <div class="text-part">${createTextHTML(textPart1)}</div>
            <br />
            <div class="text-part">${createTextHTML(textPart2)}</div>
            <br />
            <div class="text-part siteName">${createTextHTML(textPart3)}</div>
        `;

        if (animationContainerRef.current) {
            animationContainerRef.current.innerHTML = formattedHTML;

            const textParts = animationContainerRef.current.querySelectorAll('.text-part span');
            if (textParts.length > 0) {
                gsap.fromTo(
                    textParts,
                    { opacity: 0, y: -20 },
                    {
                        opacity: 1,
                        y: 0,
                        duration: 1,
                        stagger: 0.08,
                        ease: 'power2.out',
                        onComplete: () => {
                            setTimeout(() => {
                                setIsAnimationVisible(false);
                            }, 700);
                        },
                    }
                );
            }
        }
    }, []);

    return (
        <>
            <div
                className={`animation-container ${isAnimationVisible ? 'visible' : ''}`}
                ref={animationContainerRef}
            >
                <div className="animation-content"></div>
            </div>

            <div className="main">
                {!isAnimationVisible && <Header />}
            </div>
        </>
    );
};

export default Main;